import React, { useEffect, useRef, useState, useMemo } from "react";
import { FaFilter, FaPlus, FaEye, FaTrash, FaEdit } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import { RiResetLeftLine } from "react-icons/ri";
import { FaToggleOff, FaToggleOn } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RiChatFollowUpFill } from "react-icons/ri";
import { PAYMENT_STATUS_BADGE } from "../../Constant/leadConstent";
import { MdCallMissedOutgoing } from "react-icons/md";
import Search from "../../common/Search";
import Pagination from "../../common/Pagination";
import Swal from 'sweetalert2';
import { formatDate } from "../../Utils/formatters"
import { openProductModal } from "../../redux/features/productModalSlice";
import { getStaffActivity, deleteStaff, updateStaffStatus, viewStaffActivity } from "../../redux/services/Staff Services/Staff.Services";
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
const StaffActivity = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [staffActivity, setActivityData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const refreshData = useSelector((state) => state.productModal.refreshData);
  const menuRef = useRef();
  const navigate = useNavigate();


  const fetchStaff = async () => {
    try {
      // setLoading(true);

      const payload = {
        page,
        search,
        status,
      };

      const response = await getStaffActivity(payload);
      if (response?.success) {
        setActivityData(response.data || []);
        setLastPage(response.last_page || 1);
        setTotalRecords(response.total || 0);
      }
    } catch (error) {
      console.error("Failed to fetch staff:", error);
      setActivityData([]);
    } finally {
      setLoading(false);
    }
  };
  const refreshStaff = () => {
    fetchStaff();
    // setCurrentPage(1);
  };
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };
  useEffect(() => {
    fetchStaff();
  }, [page, search, status, refreshData]);
  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Activity Staff</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All Activity List </span>
              </nav>
            </div>
          </div>
          {/* 
          <button
            className="add-btn"
            onClick={() =>
              navigate("/create-transfer-inventroy")
            }
          >
            Transfer Inventory
          </button> */}
        </div>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search"
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}


        <div className="st-wrapper-card">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0 text-nowrap">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Date & Time</th>
                  <th>Staff Name</th>
                  <th>Email</th>
                  <th>Module</th>
                  <th>Action</th>
                  {/* <th>Description</th> */}
                  <th>Record ID</th>
                  <th>IP Address</th>
                  {/* <th>View</th> */}
                </tr>
              </thead>
              <tbody>
                {staffActivity.length > 0 ? (
                  staffActivity.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(page - 1) * 100 + index + 1}</td>
                      <td>{formatDate(item.created_at)}</td>
                      <td>{item.user_details?.name || "-"}</td>
                      <td>{item.user_details?.email || "-"}</td>
                      <td>{item.module || "-"}</td>
                      <td>
                        <span
                          className={`source-badge  ${PAYMENT_STATUS_BADGE[item.status?.toLowerCase()]
                            }`}
                        >
                          {item.action}
                        </span>
                      </td>
                      {/* <td
          style={{

            whiteSpace: "normal",
          }}
        >
          {item.description || "-"}
        </td> */}
                      <td>{item.record_id}</td>
                      <td>{item.ip_address || "-"}</td>
                      {/* 
        <td>
          <button
            className="btn btn-sm btn-primary"
            onClick={() =>
              navigate(`/staff-activity-detail/${item.id}`)
            }
          >
            <FaEye />
          </button>
        </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>



















  );
};

export default StaffActivity;